import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectionCell from 'shared/ui/Table/cells/SelectionCell';
import SelectionHeader from 'shared/ui/Table/cells/SelectionHeader';
import styled from 'styled-components';
import { selectAllAgents, selectRow, getAgent, unSelectAll } from 'store/Agents/actions';
import { allAgentsAreSelected, selectAgentsSelected, someAgentIsSelected } from 'store/Agents/selectors';
import get from 'lodash/get';
import { NameWrapper, Name, Categories } from '../styled';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';

const CheckHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const CheckHeader = ({ disabled }) => {
  const allAgentsSelected = useSelector(allAgentsAreSelected);
  const someAgentSelected = useSelector(someAgentIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllAgents());
  };

  return (
      <CheckHeaderContainer title="Select">
        <SelectionHeader checked={ allAgentsSelected } indeterminate={ someAgentSelected && !allAgentsSelected } onChange={ handleClick } disabled={ disabled } />
      </CheckHeaderContainer>
  );
};

export const CheckColum = ({ agent, disabled }) => {
  const agentsSelected = useSelector((state) => selectAgentsSelected(state));
  const dispatch = useDispatch();
  const isSelected = agentsSelected.find((agentSelected) => agentSelected.id === agent.id);
  const handleClick = (e) => {
    // dispatch(unSelectAll());
    dispatch(selectRow(e, agent));
  };
  return (
      <div title="Select">
        <SelectionCell checked={ !!isSelected } onChange={ handleClick } disabled={ disabled } />
      </div>
  );
};

export const NameCell = ({ agent }) => {
  const dispatch = useDispatch();
  const id = get(agent, 'id', 0);
  const name = get(agent, 'name', '');

  const handleClick = (e) => {
    dispatch(unSelectAll());
    dispatch(selectRow(e, agent));
    dispatch(getAgent(id));
    dispatch(openModal(MODAL_AGENT_DETAIL));
  };

  return (
    <NameWrapper>
      <Name onClick={ handleClick } >{ name }</Name>
    </NameWrapper>
  );
};

export const CategoriesCell = ({ agent, isCloud }) => {
  const tools = get(agent, 'executors', []);
  const categoriesUserAgent = [...new Set(tools.flatMap(el => el.category || []).filter(c => c !== null))];
  const categories = isCloud ? get(agent, 'category', []) : categoriesUserAgent;
  const parsedCategories = categories?.join(', ');

  return (
    <Categories title={ parsedCategories }>{ parsedCategories }</Categories>
  );
};
